import { Form, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { countryMapList } from '../../../data/countryMapList';
import { getCourses } from '../../../services/courseService';
import { getSignUps } from '../../../services/signUpService';
import {
  getPaymentMode,
  getPurchaseValue,
  haveCompletedPayment,
  havePaid
} from '../../../utilities/enrolmentStatus';
import { getParams } from '../../../utilities/filterConstructor';
import {
  formatEnrolmentCSVData,
  validEmail
} from '../../../utilities/formatData';
import TableWithSorter from '../../Common/TableWithSorter';
import '../index.css';
import BasicFormFilter from './BasicFormFilter';

const Listing = () => {
  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>
    },
    {
      title: 'First Name',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>{value?.basic_info?.student_info?.first_name}</span>
      )
    },
    {
      title: 'Last Name',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>{value?.basic_info?.student_info?.last_name}</span>
      )
    },
    {
      title: 'Email',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>{value?.basic_info?.student_info?.email}</span>
      )
    },
    {
      title: 'Country',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>
          {
            countryMapList[value?.basic_info?.student_info?.country_id]
              ?.name
          }
        </span>
      )
    },
    {
      title: 'Phone',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>{value?.basic_info?.student_info?.phone_number}</span>
      )
    },
    {
      title: 'ISO Code',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>
          {countryMapList[
            value?.basic_info?.student_info?.country_id
          ]?.isoCode?.toUpperCase()}
        </span>
      )
    },
    {
      title: 'Course Offer',
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => <span>{value?.course_code}</span>
    },
    {
      title: 'Status',
      render: (value) => (
        <span>{havePaid(value) ? havePaid(value) : 'No'}</span>
      )
    },
    {
      title: 'Complete payment',
      dataIndex: 'payment_details',
      key: 'payment_details',
      render: (value) => (
        <span>{haveCompletedPayment(value) ? 'Yes' : 'No'}</span>
      )
    },
    {
      title: 'Payment Mode',
      render: (value) => <span>{getPaymentMode(value)}</span>
    },
    {
      title: 'Purchase Value (USD)',
      dataIndex: 'payment_details',
      key: 'payment_details',
      render: (value) => <span>{getPurchaseValue(value)}</span>
    },
    {
      title: `Sign up time (${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      })`,
      dataIndex: 'student_details',
      key: 'student_details',
      render: (value) => (
        <span>{new Date(value?.create_time).toLocaleString()}</span>
      )
    }
  ];

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [signUps, setSignups] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(false);
  const [currentParams, setCurrentParams] = useState({});
  const [csvReport, setCsvReport] = useState({});

  const [fetching, setFetching] = useState(false);

  const getData = async (
    newParams,
    limit = pageSize,
    currentPage = current
  ) => {
    const params = newParams ? newParams : currentParams;
    setFetching(false);
    await getSignUps(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          let signUpData;
          if (process.env.REACT_APP_ENV === 'dev') {
            signUpData = res.data.paginatedList;
          } else {
            signUpData = res.data.paginatedList.filter((r) =>
              validEmail(
                r.student_details?.basic_info?.student_info?.email
              )
            );
          }
          setSignups(signUpData);
          setCsvReport(formatEnrolmentCSVData(signUpData));
          setTotalCount(res.data.totalCount);
        } else {
          console.log(res.error);
          setError(error);
        }
        setFetching(false);
      })
      .catch((e) => {
        console.log(e);
        setFetching(false);
      });
  };

  const onPaginationChange = (data) => {
    getData(currentParams, data.pageSize, data.current);
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
  };

  const [courseList, setCourseList] = useState([]);

  const getCourseList = () => {
    getCourses()
      .then((response) => {
        const courseList = response.data.paginatedList;
        const data = courseList.map((course) => ({
          label: course.code,
          value: course.code
        }));
        setCourseList(data);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  useEffect(() => {
    getData();
  }, [current, currentParams]);

  useEffect(() => {
    getCourseList();
  }, []);

  const [form] = Form.useForm();

  const onSearch = (data) => {
    const params = getParams(data);
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    setOffset(0);
    setCurrent(1);
    getData({}, pageSize, 1);
  };

  return (
    <>
      <div>Total count: {totalCount}</div>
      <div className="filter-div">
        <div className="filter-form-wrapper">
          <BasicFormFilter
            form={form}
            courses={courseList}
            onSearch={onSearch}
            onReset={onReset}
          />
        </div>
        {csvReport.data && csvReport.data.length > 0 ? (
          <CSVLink
            data={csvReport.data}
            headers={csvReport.headers}
            filename={csvReport.filename}>
            Export to CSV
          </CSVLink>
        ) : null}
      </div>

      {fetching ? <Spin /> : null}

      {signUps.length > 0 ? (
        <div className="enrolment-table">
          <TableWithSorter
            scroll={{ x: 1000 }}
            columns={columns}
            dataSource={signUps}
            pagination={{
              current: current,
              total: totalCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['20', '100', '500', '2000'],
              position: ['bottomRight', 'topLeft']
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : (
        <div>No record found</div>
      )}
    </>
  );
};

export default Listing;
